





















import { Component, Vue} from 'vue-property-decorator';
import UserMenu from './UserMenu.vue';
@Component({
  components: {
    UserMenu,
  },
})
export default class UserContainer extends Vue {
  public index: number = 0;
  public settingName: string[] = ['修改密码', '用户管理', '学校信息'];

  public mounted() {
    this.setIndex();
  }
  public beforeUpdate() {
    this.setIndex();
  }
  private setIndex() {
    let settingIndex: number = 0;
    switch (this.$route.name) {
      case 'UserList':
        settingIndex = 1;
        break;
      case 'SchoolDetail':
        settingIndex = 2;
        break;
      case 'Password':
      default:
        settingIndex = 0;
        break;
    }
    this.$set(this, 'index', settingIndex);
  }
}
